import {
    restQuery,
    QueryResult,
    BaseModel,
    restMutation,
    MutationResult,
} from 'vue-apollo-model';

// https://wiki.corp.kuaishou.com/pages/viewpage.action?pageId=673904973
export class DataCenterModel extends BaseModel {
    appId = '';
    dataTab = '';

    // 获取报表中心tab配置
    @restQuery<DataCenterModel>({
        url: '/portal/data/report/tab',
        method: 'get',
    })
    dataTabQuery!: QueryResult<Record<string, any>>;

    get isLoading() {
        return !!this.dataTabQuery.loading;
    }

    get dataCenterModule() {
        return this.dataTabQuery.data.data;
    }

    // 获取报表中心tab下的报表配置
    @restMutation<DataCenterModel>({
        url: '/portal/data/report/chart',
        method: 'get',
        variables: (p) => p,
        headers: {
            'content-type': 'application/x-www-form-urlencoded',
        },
    })
    reportChartMutation!: MutationResult<any, any>;

    get appList() {
        return this.reportChartMutation.data?.data?.appList || [];
    }

    get lastVisitApp() {
        return this.reportChartMutation.data?.data?.lastVisitApp || '';
    }

    // 统计面板的配置
    get boardList() {
        return this.reportChartMutation.data?.data?.boardList || [];
    }

    get chartGroup() {
        return this.reportChartMutation.data?.data?.chartGroup || [];
    }
    async chartMutate(params: any) {
        await this.reportChartMutation.mutate(params);
    }

    @restMutation<DataCenterModel>({
        url: '/portal/data/report/visit',
        method: 'post',
        variables: (p) => p,
        headers: {
            'content-type': 'application/x-www-form-urlencoded',
        },
    })
    reportVisitMutation!: MutationResult<any, any>;

    async reportVisitMutate(params: any) {
        await this.reportVisitMutation.mutate(params);
    }



    // 获取报表中心tab配置
    @restQuery<DataCenterModel>({
        url: '/portal/app/miniGame/data/report/app/list',
        method: 'get',
    })
    MiniGameQuery!: QueryResult<Record<string, any>>;

    // get isLoading() {
    //     return !!this.dataTabQuery.loading;
    // }

    get miniGameList() {
        return this.MiniGameQuery.data.appList;
    }
}
